"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: txactivity/activity-action.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Ftxactivity%2Factivity-action.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoReloadAction = exports.RequestReimbursementAction = exports.RedeemPointsAction = exports.ForeignChargeAction = exports.BlockMerchantAction = exports.MerchantInfoAction = exports.BnplAction = exports.MoveTransactionAction = exports.ActivityAction = void 0;
const amount_1 = require("../common/amount");
const protobufPackage = 'com.step.txactivity.proto';
function createBaseActivityAction() {
    return {
        moveTransaction: undefined,
        bnpl: undefined,
        merchantInfo: undefined,
        blockMerchant: undefined,
        foreignCharge: undefined,
        redeemPoints: undefined,
        requestReimbursement: undefined,
        autoReload: undefined,
    };
}
exports.ActivityAction = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.moveTransaction)) {
            message.moveTransaction = exports.MoveTransactionAction.fromJSON(object.moveTransaction);
        }
        if (isSet(object.bnpl)) {
            message.bnpl = exports.BnplAction.fromJSON(object.bnpl);
        }
        if (isSet(object.merchantInfo)) {
            message.merchantInfo = exports.MerchantInfoAction.fromJSON(object.merchantInfo);
        }
        if (isSet(object.blockMerchant)) {
            message.blockMerchant = exports.BlockMerchantAction.fromJSON(object.blockMerchant);
        }
        if (isSet(object.foreignCharge)) {
            message.foreignCharge = exports.ForeignChargeAction.fromJSON(object.foreignCharge);
        }
        if (isSet(object.redeemPoints)) {
            message.redeemPoints = exports.RedeemPointsAction.fromJSON(object.redeemPoints);
        }
        if (isSet(object.requestReimbursement)) {
            message.requestReimbursement = exports.RequestReimbursementAction.fromJSON(object.requestReimbursement);
        }
        if (isSet(object.autoReload)) {
            message.autoReload = exports.AutoReloadAction.fromJSON(object.autoReload);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.moveTransaction !== undefined) {
            obj.moveTransaction = exports.MoveTransactionAction.toJSON(message.moveTransaction);
        }
        if (message.bnpl !== undefined) {
            obj.bnpl = exports.BnplAction.toJSON(message.bnpl);
        }
        if (message.merchantInfo !== undefined) {
            obj.merchantInfo = exports.MerchantInfoAction.toJSON(message.merchantInfo);
        }
        if (message.blockMerchant !== undefined) {
            obj.blockMerchant = exports.BlockMerchantAction.toJSON(message.blockMerchant);
        }
        if (message.foreignCharge !== undefined) {
            obj.foreignCharge = exports.ForeignChargeAction.toJSON(message.foreignCharge);
        }
        if (message.redeemPoints !== undefined) {
            obj.redeemPoints = exports.RedeemPointsAction.toJSON(message.redeemPoints);
        }
        if (message.requestReimbursement !== undefined) {
            obj.requestReimbursement = exports.RequestReimbursementAction.toJSON(message.requestReimbursement);
        }
        if (message.autoReload !== undefined) {
            obj.autoReload = exports.AutoReloadAction.toJSON(message.autoReload);
        }
        return obj;
    },
    create(base) {
        return exports.ActivityAction.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseActivityAction();
        message.moveTransaction =
            (object.moveTransaction !== undefined && object.moveTransaction !== null)
                ? exports.MoveTransactionAction.fromPartial(object.moveTransaction)
                : undefined;
        message.bnpl = (object.bnpl !== undefined && object.bnpl !== null)
            ? exports.BnplAction.fromPartial(object.bnpl)
            : undefined;
        message.merchantInfo = (object.merchantInfo !== undefined && object.merchantInfo !== null)
            ? exports.MerchantInfoAction.fromPartial(object.merchantInfo)
            : undefined;
        message.blockMerchant = (object.blockMerchant !== undefined && object.blockMerchant !== null)
            ? exports.BlockMerchantAction.fromPartial(object.blockMerchant)
            : undefined;
        message.foreignCharge = (object.foreignCharge !== undefined && object.foreignCharge !== null)
            ? exports.ForeignChargeAction.fromPartial(object.foreignCharge)
            : undefined;
        message.redeemPoints = (object.redeemPoints !== undefined && object.redeemPoints !== null)
            ? exports.RedeemPointsAction.fromPartial(object.redeemPoints)
            : undefined;
        message.requestReimbursement =
            (object.requestReimbursement !== undefined && object.requestReimbursement !== null)
                ? exports.RequestReimbursementAction.fromPartial(object.requestReimbursement)
                : undefined;
        message.autoReload = (object.autoReload !== undefined && object.autoReload !== null)
            ? exports.AutoReloadAction.fromPartial(object.autoReload)
            : undefined;
        return message;
    },
};
function createBaseMoveTransactionAction() {
    return { remainingAmount: amount_1.Amount.fromPartial({}), isToCredit: false };
}
exports.MoveTransactionAction = {
    fromJSON(object) {
        const message = {
            remainingAmount: isSet(object.remainingAmount)
                ? amount_1.Amount.fromJSON(object.remainingAmount)
                : amount_1.Amount.fromPartial({}),
            isToCredit: isSet(object.isToCredit) ? globalThis.Boolean(object.isToCredit) : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.remainingAmount !== undefined) {
            obj.remainingAmount = amount_1.Amount.toJSON(message.remainingAmount);
        }
        if (message.isToCredit !== false) {
            obj.isToCredit = message.isToCredit;
        }
        return obj;
    },
    create(base) {
        return exports.MoveTransactionAction.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMoveTransactionAction();
        message.remainingAmount =
            (object.remainingAmount !== undefined && object.remainingAmount !== null)
                ? amount_1.Amount.fromPartial(object.remainingAmount)
                : amount_1.Amount.fromPartial({});
        message.isToCredit = object.isToCredit ?? false;
        return message;
    },
};
function createBaseBnplAction() {
    return {};
}
exports.BnplAction = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.BnplAction.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseBnplAction();
        return message;
    },
};
function createBaseMerchantInfoAction() {
    return {};
}
exports.MerchantInfoAction = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.MerchantInfoAction.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseMerchantInfoAction();
        return message;
    },
};
function createBaseBlockMerchantAction() {
    return { merchantId: '' };
}
exports.BlockMerchantAction = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.merchantId)) {
            message.merchantId = globalThis.String(object.merchantId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.merchantId !== undefined && message.merchantId !== '') {
            obj.merchantId = message.merchantId;
        }
        return obj;
    },
    create(base) {
        return exports.BlockMerchantAction.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBlockMerchantAction();
        message.merchantId = object.merchantId ?? '';
        return message;
    },
};
function createBaseForeignChargeAction() {
    return {};
}
exports.ForeignChargeAction = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.ForeignChargeAction.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseForeignChargeAction();
        return message;
    },
};
function createBaseRedeemPointsAction() {
    return {};
}
exports.RedeemPointsAction = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.RedeemPointsAction.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseRedeemPointsAction();
        return message;
    },
};
function createBaseRequestReimbursementAction() {
    return {};
}
exports.RequestReimbursementAction = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.RequestReimbursementAction.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseRequestReimbursementAction();
        return message;
    },
};
function createBaseAutoReloadAction() {
    return {};
}
exports.AutoReloadAction = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.AutoReloadAction.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseAutoReloadAction();
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=activity-action.js.map